export const braceClose = <>&#125;</>; // prints }
export const braceOpen = <>&#123;</>; // prints {
export const bracketClose = <>&#93;</>; // prints ]
export const bracketOpen = <>&#91;</>; // prints [
export const colon = <>&#58;</>; // prints :
export const ellipsis = <>&#46;&#46;&#46;</>; // prints ...
export const quote = <>&quot;</>; // prints "
